import { useCallback, useState } from 'react';

import { DETAILS_DATA_TYPES } from 'store/details/utils/constants.ts';
import isVodEditorialsResponse from 'store/details/utils/isVodEditorialsResponse.ts';

import { getSettledResponseData } from 'utils/axios/nagra/utils.ts';

import { noSeasonName } from '../constants.ts';
import { SeasonListItem } from '../types.ts';
import isSeasonsListResponse from '../utils/isSeasonsListResponse.ts';
import requestNoSeasonEpisodesData from '../utils/requestNoSeasonEpisodesData.ts';
import requestSeasonsNumbersData from '../utils/requestSeasonsNumbersData.ts';

function useVodSeasons() {
    const [vodSeasons, setVodSeasons] = useState<SeasonListItem[]>([]);

    const handleLoadVODSeasonsList = useCallback(
        async (_seriesId: string, _channelId: string | undefined) => {
            const [
                vodSeasonsListSettledResponse,
                noSeasosEpisodesSettledResponse,
            ] = await Promise.allSettled([
                requestSeasonsNumbersData(DETAILS_DATA_TYPES.VOD, _seriesId),
                requestNoSeasonEpisodesData(
                    DETAILS_DATA_TYPES.PROGRAM,
                    _seriesId,
                    _channelId,
                    undefined,
                    0,
                ),
            ]);
            const vodSeasonsListResponse = getSettledResponseData(
                vodSeasonsListSettledResponse,
            );
            const noSeasonEpisodesResponse = getSettledResponseData(
                noSeasosEpisodesSettledResponse,
            );

            if (isSeasonsListResponse(vodSeasonsListResponse)) {
                const seasonsList =
                    vodSeasonsListResponse.data.values.map<SeasonListItem>(
                        (s) => ({
                            seasonId: s,
                            seasonNumber: Number(s),
                        }),
                    );

                if (
                    isVodEditorialsResponse(noSeasonEpisodesResponse) &&
                    noSeasonEpisodesResponse.data.total_records > 0
                ) {
                    seasonsList.push({
                        seasonId: noSeasonName,
                        seasonNumber: noSeasonName,
                    });
                }

                setVodSeasons(seasonsList);

                return seasonsList;
            }

            return [];
        },
        [],
    );

    return { seasons: vodSeasons, onLoadSeasons: handleLoadVODSeasonsList };
}

export default useVodSeasons;
